import * as React from 'react';
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AttractionsIcon from '@mui/icons-material/Attractions';
import CollectionsIcon from '@mui/icons-material/Collections';
import MovieIcon from '@mui/icons-material/Movie';
import PersonIcon from '@mui/icons-material/Person';
import InfoIcon from '@mui/icons-material/Info';
import NavItem from './NavItem';
import { useNavigate } from 'react-router-dom';

const drawerWidth = 240;

const openedMixin = (theme: Theme, width: number): CSSObject => ({
  width,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
  }),
);

export default function MiniDrawer() {
  const theme = useTheme();
  const isNarrowScreen = useMediaQuery('(max-width:1520px)');
  const drawerWidthValue = isNarrowScreen ? 180 : drawerWidth;
  const [open, setOpen] = React.useState(true);
  const navigate = useNavigate();

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />      
      <Drawer
        className="nav-drawer"
        variant="permanent"
        open={open}
        sx={{
          width: drawerWidthValue,
          ...(open && {
            ...openedMixin(theme, drawerWidthValue),
            '& .MuiDrawer-paper': openedMixin(theme, drawerWidthValue),
          }),
          ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
          }),
        }}
      >
        <DrawerHeader>
          <IconButton onClick={() => setOpen(!open)}>
            {open
              ? theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />
              : theme.direction === 'rtl' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>          
          <NavItem title="Dashboard" open={open} onClick={() => navigate("/")}><DashboardIcon /></NavItem>
          <NavItem title="Kampanyalar" open={open} onClick={() => navigate("/campaigns")}><AttractionsIcon /></NavItem>
          <NavItem title="Video Galerisi" open={open} onClick={() => navigate("/video-gallery")}><MovieIcon /></NavItem>
          <NavItem title="Görsel Galerisi" open={open} onClick={() => navigate("/photo-gallery")}><CollectionsIcon /></NavItem>
          <NavItem title="Görsel Kılavuzu" open={open} onClick={() => navigate("/photo-guide")}><InfoIcon /></NavItem>
          <NavItem title="Oyuncular" open={open} onClick={() => navigate("/players")}><PersonIcon /></NavItem>
        </List>
        <Divider />
      </Drawer>
    </Box>
  );
}
